import React, { Component } from 'react';
import { Row, Col, FormGroup, Radio } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { getMemberNameByUserId } from '../../utils';
import getContent from './Contents/Indemnification';
import Select from '../Select';

export default class Indemnification extends Component {
  options = () => ({
    field1: this.props.field1,
    field2: this.props.field2,
    name: this.props.name || '',
  });

  handleContent(index) {
    const options = this.options();
    options.field1 = index;

    this.props.updateBlock(this.props.block.id, getContent(options), options);
  }

  handleMembers(e) {
    const options = this.options();
    const name = e.target.options[e.target.selectedIndex].text;
    options.field1 = 1;
    options.field2 = e.target.value;
    options.name = name;

    this.props.updateBlock(this.props.block.id, getContent(options), options);
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          <Col sm={12}>
            <p className="question">
              Will any collaborator indemnify the others?
            </p>
            <FormGroup className="answer">
              <Radio
                name="indemnification"
                checked={this.props.field1 === 0}
                readOnly
                onClick={(e) => this.handleContent(0)}
              >
                Each collaborator will indemnify the others against third party
                legal claims arising out of their breach of this agreement.
              </Radio>
              <Radio
                name="indemnification"
                checked={this.props.field1 === 1}
                readOnly
                onClick={(e) => this.handleContent(1)}
              >
                <Select
                  className="select-mini"
                  value={this.props.field2}
                  onChange={(e) => this.handleMembers(e)}
                >
                  <option value="">Select Collaborator</option>
                  {this.props.workOwnerships &&
                    this.props.workOwnerships.map((member, i) => (
                      <option key={i} value={member.user}>
                        {getMemberNameByUserId(member.user, this.props.members)}
                      </option>
                    ))}
                </Select>
                will indemnify the other collaborators and cover any losses
                caused by their individual actions or third party legal actions
                against them.
              </Radio>
              <Radio
                name="indemnification"
                checked={this.props.field1 === 2}
                readOnly
                onClick={(e) => this.handleContent(2)}
              >
                No indemnification.
              </Radio>
            </FormGroup>
          </Col>

          <Col sm={12}>{this.props.children}</Col>

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  Things can go wrong. When this happens, this clause provides
                  guidelines for the protection of collaborators who are not at
                  fault and the responsibilities of the collaborators who are at
                  fault.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is indemnification?</p>
                <p className="small">
                  “Indemnification” is a promise by one party to cover the
                  losses another party may suffer because of third party legal
                  action taken against them as a result of the indemnifying
                  party’s breach of the agreement.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/ContractBlock/Indemnification.jsx